export const iconFontAwesomeEnergyPlug = (
	<i className="fa-solid fa-plug"></i>
);
